import type {
  NicknameAvailabilityResponse,
  ProfileResponse,
  UpdateProfileRequest,
} from "@qota/shared";
import { request } from "./http";

export function getProfile(): Promise<ProfileResponse> {
  return request<ProfileResponse>("GET", "/me");
}

export function updateProfile(input: UpdateProfileRequest): Promise<ProfileResponse> {
  return request<ProfileResponse>("PATCH", "/me", input);
}

export function checkNickname(nickname: string): Promise<NicknameAvailabilityResponse> {
  return request<NicknameAvailabilityResponse>(
    "GET",
    `/nicknames/${encodeURIComponent(nickname)}/availability`,
  );
}
